import { render, staticRenderFns } from "./ScoutingReportsAdminDashboard.vue?vue&type=template&id=c4b436e8&"
import script from "./ScoutingReportsAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportsAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports